import React, { useState, useEffect } from 'react';
import api from "../../../../services/api";
import Empresa from '../../../../entities/Common/Empresa'
import Pagamento  from '../../../../entities/Common/Pagamento'
import List from './List'
import Form from './Form'

import {
    Button,
    Row,
    Col,
} from "reactstrap"

//Definindo as propriedades desse componente 
type Props = {
    onEmpresaChange(empresa: Empresa): void,
    notify(type: string, msg: string): void,
    empresa: Empresa
}

const Pagamentos: React.FC<Props> = ({
    onEmpresaChange,
    notify,
    empresa
}) => {

    const [pagamentos, setPagamentos] = useState(new Array<Pagamento>())
    const [showForm, setShowForm] = useState(false)

    useEffect(() => {
        if (empresa.id) {
            load()
        }
    }, [empresa])

    async function load() {
       try {
            const response = await api.get(`/common/empresas/${empresa.id}/pagamentos`)
            setPagamentos(await response.data)

        } catch (error) {
            console.log(error)
            notify('danger', 'Não foi possível carregar os pagamentos da empresa')
        }

    }

    function hideForm() {
        setShowForm(false)
    }

    function handleShowForm() {
        setShowForm(true)
    }

    return (
        <>
            <Form
                empresa={empresa}
                hide={hideForm}
                notify={notify}
                success={load}
                show={showForm}
                pagamento={{} as Pagamento}
            />
            <div
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center'
                }}
            >
                <Button
                    color="primary"
                    type="button"
                    className="btn-icon btn-3"
                    onClick={handleShowForm}

                >
                    <span className="btn-inner--icon">
                        <i className="ni ni-fat-add"></i>
                    </span>
                    <span className="btn-inner--text">Novo Pagamento</span>
                </Button>
                <Button
                    color="primary"
                    type="button"
                    className="btn-icon btn-3"
                    onClick={load}

                >
                    <span className="btn-inner--icon">
                        <i className="fas fa-sync"></i>
                    </span>
                    <span className="btn-inner--text">Atualizar</span>
                </Button>
            </div>
            <List
                pagamentos={pagamentos}
                empresa={empresa}
                notify={notify}
                reLoad={load}
            />
        </>
    );
}



export default Pagamentos;